import { formatMoney } from 'libs/shopify'
import { select } from 'helpers/dom'

const selectors = {
  DONATION_COUNTER_SELECTOR: '.js-donation-counter'
}

class DonationCounter extends HTMLElement {
  constructor() {
    super()

    const { donationKey } = window.GM_STATE.apis

    this.donationCounterEl = select(selectors.DONATION_COUNTER_SELECTOR, this)
    this.siteId = donationKey.siteId
    this.siteKey = donationKey.siteKey
    this.endPoint = donationKey.endPoint
  }

  loadDonationData() {
    const headers = new Headers()
    const base64Credentials = btoa(`${this.siteId}:${this.siteKey}`)

    headers.append('Authorization', `Basic ${base64Credentials}`)
    headers.append('Accept', '*/*')

    fetch(this.endPoint, {
      method: 'GET',
      headers
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Network response was not ok ${response.statusText}`)
        }

        return response.json()
      })
      .then((data) => {
        if (this.donationCounterEl) {
          this.donationCounterEl.innerText = formatMoney(data.donation)
        }
      })
      .catch((error) => {
        throw new Error(error)
      })
  }

  connectedCallback() {
    this.loadDonationData()
  }
}

if (!customElements.get('donation-counter')) {
  customElements.define('donation-counter', DonationCounter)
}
